export const AnalysisOptions = [

    { "value": '', label: 'Select Analysis Type', disabled: true },
    { "value": 'Replicate Analysis', label: 'Replicate Analysis' },
    { "value": 'Single Well Analysis', label: 'Single Well Analysis' },
    { "value": 'Control/Experiment Analysis', label: 'Control/Experiment Analysis' }
];

export const Experiments = [
    { "value": 'duplex', label: 'Duplex' }
];

export const Replicates =
    [
        'Technical Replicates',
        'By Column',
        'By Row',
        'By Sample Name',
        'By Assay/Target'
    ];

export const Analysis = {
    replicate: "Replicate Analysis",
    singlewell: "Single Well Analysis",
    controlexp: "Control/Experiment Analysis",
};